import sdgsController from "../../../controllers/sdgsController/controller";
import Swal from 'sweetalert2';
import { EventBus } from "@/eventBus";
import config from "../../../../config";
export default {
    name: 'SimpleTable',
    data(){
        return{
            company: '',
            gambarName: 'Pilih Gambar',
            gambarUrl: '',
            sdgsList: [],
            currentPage: 1,
            allIcons: [],
            dropdownOpen: false,
            icons: [],
            pageSize: 10,
            apiUrl: config.AWS_URL + 'gambar/sdgs/',
            totalSdgs: 0,
            totalPages: 0,
            searchQuery: '',
            sizes: [1,5,10,20],
            sdgs : {
                id: '',
                name : '',
                deskripsi : '',
                sdgs : '',
                icon: '',
                language: '',
                status: '',
                created_by: '',
                created_by_name: '',
                created_on: '',
            },
            selectedSdgs:{
                updated_by: '',
                updated_by_name: '',
            }
        }
    },
    computed:{
        filteredSdgs(){
            return this.sdgsList.filter((sdgs) => {
                return sdgs.name.toLowerCase().includes(this.searchQuery.toLowerCase());
            });
        },
        pages(){
            return Math.ceil(this.totalSdgs / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods:{
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.sdgs.created_by = id;
            this.selectedSdgs.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.sdgs.created_by_name = name;
            this.selectedSdgs.updated_by_name = name;
        },
        showModal(type, id) {
            this.user()
            const sdgs = this.sdgsList.find(sdgs => sdgs.id === id);
            if (sdgs) {
                this.sdgs = sdgs;
                
                const modal = document.getElementById(type === 'edit' ? 'editSdgs' : 'detailSdgs');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
            const modalIds = ['tambahSdgs', 'editSdgs', 'detailSdgs'];
            modalIds.forEach(id => {
                const modal = document.getElementById(id);
                if (modal && modal.classList.contains('show')) {
                modal.classList.remove('show');
                setTimeout(() => {
                    modal.style.display = 'none';
                }, 300);
                }
            });
            
            // Hapus backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => {
                backdrop.classList.remove('show');
                setTimeout(() => {
                if (backdrop.parentNode) {
                    backdrop.parentNode.removeChild(backdrop);
                }
                }, 300);
            });
            
            // Hapus kelas atau atribut yang mengunci scroll pada body
            const body = document.body;
            body.classList.remove('modal-open');
            body.style.overflow = ''; // Menghapus properti overflow jika ada
            this.fetchSdgs();
            this.resetForm();
            this.user();
        },    
        resetForm() {
            this.gambarName = 'Pilih Url',
            this.gambarUrl = '',
            this.sdgs.name = '',
            this.sdgs.sdgs= '',
            this.sdgs.deskripsi = '',
            this.sdgs.language = '',
            this.sdgs.icon = '',
            this.iconSearch = '',
            this.icon();
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchSdgs();
            }
        },
        async fetchSdgs() {
            try{
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await sdgsController.fetchSdgs(query, this.currentPage, this.pageSize, company);
                this.sdgsList = response.data;
                this.totalAllSdgs();
            } catch (error) {
                console.error('Error fetching sdgs:', error);
            }
        },
        async totalAllSdgs() {
            try{
                const company = this.company;
                const response = await sdgsController.totalAllSdgs(company);
                this.totalSdgs = response.data;
            } catch (error) {
                console.error('Error fetching sdgs:', error);
            }
        },
        async handleFileUpload(event) {
            try{
                const file = event.target.files[0];
                if (file) {
                    this.gambarName = file.name;
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.gambarUrl = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
                if (!file) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Silahkan pilih file',
                        timer: 1500
                    })
                    return;
                }
    
                // Validasi tipe file (opsional)
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
                if (!allowedTypes.includes(file.type)) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Hanya file gambar yang diperbolehkan',
                        timer: 1500
                    })
                    return;
                }

                const allowedSize = 1 * 1024 * 1024; // 1 MB
                if (file.size > allowedSize) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops..',
                        text: `Ukuran file terlalu besar, maksimal ${allowedSize / 1024 / 1024} MB`,
                        timer: 1500
                    })
                    this.resetForm();
                    return;
                }
                this.sdgs.sdgs = file;
            } catch (error) {
                console.error('Error uploading file:', error);
                alert('Gagal mengunggah file');
            }
        },
        async addSdgs() {
            try{
                Swal.fire({
                    title: 'Loading...',
                    text: 'Please wait while the client is being deleted',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        Swal.showLoading();
                    }
                });
                const formData = new FormData();
                const now = new Date();
                this.sdgs.created_on = now.toISOString().slice(0, 19).replace('T', ' ');
                formData.append('name', this.sdgs.name);
                formData.append('sdgs', this.sdgs.sdgs);
                formData.append('deskripsi', this.sdgs.deskripsi);
                formData.append('language', this.sdgs.language);
                formData.append('company', this.company);
                formData.append('icon', this.sdgs.icon);
                formData.append('status', this.sdgs.status);
                formData.append('created_by', this.sdgs.created_by);
                formData.append('created_by_name', this.sdgs.created_by_name);
                formData.append('created_on', this.sdgs.created_on);
                const response = await sdgsController.addSdgs(formData,{
                    headers:{
                        'Content-Type': 'multipart/form-data'
                    }
                });
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'SDGS berhasil ditambahkan',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.closeModal();
                    this.fetchSdgs();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'SDGS gagal ditambahkan',
                        timer: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'SDGS gagal ditambahkan',
                    timer: 1500
                })
                throw error;
            }
        },
        async updateSdgs() {
            try{
                const id = this.sdgs.id;
                const name = this.sdgs.name;
                const content = this.sdgs.content;
                const language = this.sdgs.language;
                const icon = this.sdgs.icon;
                const status = this.sdgs.status;
                const updated_by = this. selectedSdgs.updated_by;
                const updated_by_name = this.selectedSdgs.updated_by_name;
                const now = new Date();
                const updated_on = now.toISOString().slice(0,19).replace('T', ' ');
                if (!id || !name || !language || !content || !icon || !status || !updated_by || !updated_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal memperbaharui data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                }
                const update = {
                    id: id,
                    name: name,
                    content: content,
                    language: language,
                    icon: icon,
                    is_active: status,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name,
                    updated_on: updated_on
                }
                const data = await sdgsController.updateSdgs(update);
                if (data.status == 200) {                    
                    Swal.fire({
                        icon: 'success',
                        title: 'SDGS berhasil diperbaharui',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.closeModal();
                    this.fetchSdgs();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'SDGS gagal diperbaharui',
                        timer: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'SDGS gagal diperbaharui',
                    timer: 1500
                })
            }
        },
        async deleteSdgs(sdgsId, sdgs){
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try {
                    Swal.fire({
                        title: 'Loading...',
                        text: 'Please wait while the client is being deleted',
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        willOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    const response = await sdgsController.deleteSdgs(sdgsId, sdgs);
                    if (response.status === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Data berhasil dihapus',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Data gagal dihapus',
                            showConfirmButton: false,
                            timer: 1500
                        })  
                    }
                    this.fetchSdgs();
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Data gagal dihapus',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        },
        async icon(){
            const res = await fetch('https://raw.githubusercontent.com/twbs/icons/main/font/bootstrap-icons.json');
            const data = await res.json();
            this.allIcons = Object.keys(data).map(name => `bi bi-${name}`);
            this.icons = this.allIcons;
        },
        selectIcon(icon) {
            this.sdgs.icon = icon;
            this.dropdownOpen = false;
        },
        searchIcon() {
            const keyword = this.iconSearch.toLowerCase();
            this.icons = this.allIcons.filter(icon =>
                icon.toLowerCase().includes(keyword)
            );
        }
    },
    mounted(){
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
        this.icon();
        this.icons = this.allIcons; 
    },
    watch:{
        searchQuery:{
            handler: 'fetchSdgs'
        },
        company: {
            handler: 'fetchSdgs'
        }
    },
    created() {
        this.icons = this.allIcons; // Awal: tampilkan semua
    },
}